import React, { useMemo } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as bookmarksActions from '~data/actions/bookmarks'
import { makeCollection } from '~data/selectors/collections'
import { makeStatus, getSearchEmpty } from '~data/selectors/bookmarks'

import View from './view'

export default function BookmarksEmpty({ spaceId = 0, compact = false, ...etc }) {
    const dispatch = useDispatch()
    const getStatus = useMemo(() => makeStatus(), [])
    const getCollection = useMemo(() => makeCollection(), [])

    const collection = useSelector(state => getCollection(state, spaceId))
    const status = useSelector(state => getStatus(state, spaceId))
    const searchEmpty = useSelector(state => getSearchEmpty(state, spaceId))
    const actions = useMemo(() => bindActionCreators(bookmarksActions, dispatch), [dispatch])

    return (
        <View
            {...etc}
            spaceId={spaceId}
            compact={compact}
            collection={collection}
            status={status}
            searchEmpty={searchEmpty}
            actions={actions} />
    )
}
